import { getLocale, LOCALES } from 'utils';
import { KK_MONTHS } from 'common/constants';

export const getDate = (date: Date, locale: string) => {
  const isoLocale = getLocale(locale);

  if (isoLocale === LOCALES.get('kk')) {
    return `${date.getDate()} ${KK_MONTHS[date.getMonth()]} ${date.getFullYear()}`;
  }

  const dtf = Intl.DateTimeFormat(isoLocale, { day: 'numeric', month: 'long' });

  return `${dtf.format(date)} ${date.getFullYear()}`;
};
